import { n0, pct, plural } from '../lib/format';

export const Card = ({ children, className = '', ...rest }) => (
  <div className={`card ${className}`} {...rest}>{children}</div>
);

export const CardHead = ({ title, caption }) => (
  <>
    <h3>{title}</h3>
    {caption ? <p className="capt">{caption}</p> : null}
  </>
);

export const Section = ({ title, hint }) => (
  <div className="sec">
    <h2>{title}</h2>
    {hint ? <p>{hint}</p> : null}
  </div>
);

export function Delta({ value }) {
  if (value === null || value === undefined || !isFinite(value)) return null;
  const cls = Math.abs(value) < 0.005 ? 'flat' : value > 0 ? 'up' : 'down';
  return (
    <span className={`delta ${cls}`}>
      {value > 0 ? '+' : ''}
      {(value * 100).toLocaleString('ru-RU', { maximumFractionDigits: 0 })}%
    </span>
  );
}

export function Kpi({ label, value, unit, delta, note, small }) {
  return (
    <div className="card kpi">
      <div className="k-label">{label}</div>
      <div className="k-val" style={small ? { fontSize: 30 } : undefined}>
        {value}
        {unit ? <small>{unit}</small> : null}
      </div>
      <div className="k-foot">
        <Delta value={delta} />
        {note ? <span className="k-note">{note}</span> : null}
      </div>
    </div>
  );
}

export function Badge({ children, cls = 'b-expired', title }) {
  return <span className={`badge ${cls}`} title={title}>{children}</span>;
}

export function PlanBadge({ plan, published = true, note }) {
  return (
    <>
      <span className="badge b-plan">{plan}</span>
      {published ? null : (
        <>
          {' '}
          <span className="badge b-hidden" title={note || 'тариф не опубликован на сайте'}>не на витрине</span>
        </>
      )}
    </>
  );
}

/* Занято/лимит с полосой. Красится по заполнению, а не по тарифу. */
export function Usage({ used, max, fmt = n0, updating }) {
  const rate = max ? used / max : 0;
  const cls = rate > 0.95 ? ' d' : rate > 0.8 ? ' w' : '';
  const color = rate > 0.95 ? 'var(--bad)' : rate > 0.8 ? 'var(--warn)' : undefined;
  return (
    <div className="usecell" title={updating ? 'значение пересчитывается после удаления файлов' : undefined}>
      <span className="muted" style={{ fontSize: 11, opacity: updating ? 0.5 : 1 }}>
        {fmt(used)} / {max ? fmt(max) : '∞'}
      </span>
      <span className={`bar${cls}`}>
        <i style={{ width: Math.min(100, rate * 100).toFixed(0) + '%' }} />
      </span>
      <span className="pct" style={{ color }}>{max ? pct(rate) : '—'}</span>
    </div>
  );
}

export const Loading = ({ what = 'данные' }) => (
  <div className="state"><span className="spin" /> загружаем {what}…</div>
);

export const ErrorState = ({ error, onRetry }) => (
  <div className="state err">
    <div>{error?.message || 'Не удалось загрузить данные.'}</div>
    {onRetry ? <button className="btn" onClick={onRetry}>попробовать снова</button> : null}
  </div>
);

export const Empty = ({ children = 'здесь пока пусто' }) => <div className="empty">{children}</div>;

export const Count = ({ n, one, few, many }) => (
  <>{n0(n)} {plural(n, one, few, many)}</>
);
